import * as runtime from '@/api/runtime'
import {
  BatchLendDbUpdateRequest,
  BatchLendDbUpdateRequestToJSON,
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api/models/batch'
import {
  BatchLendDbUpdateCondition,
  BatchLendDbUpdateConditionFromJSON
} from '@/api/models/batch/BatchLendDbUpdateCondition'

/**
 * 帳票作成
 */
export class BatchLendDbUpdateApi extends runtime.BaseAPI {
  async return(request: BatchLendDbUpdateRequest): Promise<number> {
    const response = await this.requestPost(
      `/batch/lend/lend-db-update`,
      BatchLendDbUpdateRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async getInitialCondition(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchLendDbUpdateCondition> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchLendDbUpdateConditionFromJSON(jsonValue)
    ).value()
  }
}
